/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable object-curly-newline */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as Joi from 'joi-browser';

import withStyles from '@material-ui/core/styles/withStyles';

import Form from '../Form';
import Divider from '../Divider';
import { form as FormStyle } from '../../style/form';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import configENV from '../../config';

const { PERSIST_KEY } = configENV;
const styles = ({ typography, palette }) => FormStyle(typography, palette);

class LoginForm extends Form {
    state = {
        data: {
            email: '',
            password: '',
        },
        errors: {},
    };

    schema = {
        email: Joi.string()
            .email({ minDomainSegments: 2 })
            .trim()
            .max(50)
            .required()
            .label('Email Address'),
        password: Joi.string()
            .trim()
            .min(6)
            .max(50)
            .required()
            .label('Password'),
    };

    doSubmit = () => {
        const { data } = this.state;
        data.callBack = { url: '/account' };
        this.props.handleAccountSignIn(data);
    };

    handleResetPasswordClicked = () => {
        const { data } = this.state;
        delete data.password;
        this.props.handleClickResetPassword(data);
        this.props.history.push('/account/reset-password');
    };

    handleCreateAccountClicked = () => {
        this.props.handleClearPageData();
        this.props.history.push('/account/create-account');
    };

    render() {
        /* eslint-disable max-len */
        const { classes, hideCreateAccount } = this.props;
        // const { data } = this.state;
        const submitData = {};

        return (
            <>
                <h1>Returning Customers, Sign In</h1>
                <p className="margin-bottom-2x">
                    Welcome back! Sign in for fast and easy checkout.
                </p>
                <form
                    onSubmit={(event) => this.handleSubmit(event, submitData)}
                    className={`${classes.form} row`}
                >
                    <div>
                        {this.renderInput({
                            name: 'email',
                            label: 'Email Address',
                            type: 'email',
                            pattern: '^[0-9_a-zA-Z\\s\\.\\-@]*$',
                            length: 50,
                        })}
                        {this.renderInput({
                            name: 'password',
                            label: 'Password',
                            type: 'password',
                            length: 50,
                        })}
                    </div>

                    <div className="margin-top-2x">
                        {this.renderButton({
                            label: 'Sign In',
                            className: 'buttonHD sign-in-btn',
                            onClick: null,
                            type: 'submit',
                        })}
                    </div>

                    <div className="margin-top-2x align-center">
                        {this.renderButton({
                            label: 'Forgot / Reset password',
                            className: 'forgot-password-btn link no-underline small',
                            onClick: this.handleResetPasswordClicked,
                            type: 'button',
                            isValidated: false,
                        })}
                    </div>
                    {!hideCreateAccount ? (
                        <>
                            <Divider text="or" />

                            <div className="margin-top-2x padding-bottom-2x align-center">
                                {this.renderButton({
                                    label: 'Create Account',
                                    className: 'buttonHDSecondary create-account-btn',
                                    onClick: this.handleCreateAccountClicked,
                                    type: 'button',
                                    isValidated: false,
                                })}
                            </div>
                        </>
                    ) : (
                        ''
                    )}
                </form>
            </>
        );
    }
}

LoginForm.defaultProps = {
    isAuthenticated: false,
    hideCreateAccount: false,
    description: {},
    handleAccountSignIn: () => { },
    handleClickResetPassword: () => { },
};

LoginForm.propTypes = {
    classes: PropTypes.object.isRequired,
    isAuthenticated: PropTypes.bool,
    hideCreateAccount: PropTypes.bool,
    description: PropTypes.object,
    handleAccountSignIn: PropTypes.func,
    handleClickResetPassword: PropTypes.func,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isAuthenticated: newState.isAuthenticated,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleAccountSignIn: (data) => dispatch(EventDispatcher.handleAccountSignIn(data)),
    handleClickResetPassword: (data) => dispatch(EventDispatcher.handleClickResetPassword(data)),
    handleClearPageData: () => dispatch(EventDispatcher.handleClearPageData()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles)(LoginForm)));
